import React from 'react'
import TextInput from '../../../../shared/TextInput'
import CustomButton from '../../../../shared/CustomButton'
import { FaCheckDouble } from 'react-icons/fa'
import { useTranslation } from 'react-i18next'

function ReceiveForm ({ closeModal }) {
  const { t } = useTranslation()
  return (
    <div>
      <TextInput
        useFormik={false}
        label={t('ReceiveRemark')}
        name='receiveRemark'
        placeholder={t('EnterReceiveRemark')}
        className='w-full'
      />
      <div className='flex justify-end items-center mt-4'>
        <CustomButton
          label={t('Submit')}
          icon={FaCheckDouble}
          onClick={closeModal}
          type='button'
        />
      </div>
    </div>
  )
}

export default ReceiveForm
